import React from 'react';
import TableDataField from './TableDataField';

const CodeDescriptionField = ({ codeDescription, height }) => {
    height = height ?? '40px';
    return <TableDataField extraStyling="col-med-large">{codeDescription}</TableDataField>;
};

export default CodeDescriptionField;
